module.exports = __webpack_public_path__ + "static/media/file.4be79529.svg";